import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import DynamicFaqs from "../../Components/home/Faqs";
import { Link } from "react-router-dom";

const NewYeargifts = () => {
  const CTAContent = [
    {
      pageName: "New Year Gifts",
      paragraphitalic: "Start the Year with a Bang! ",
      paragraphText:
        "The New Year is more than just a change in the calendar, it's an opportunity to express gratitude, strengthen relationships, and start the year on a positive note. For businesses, corporate New Year gifts are a meaningful way to appreciate employees, clients, and partners who contributed to success throughout the year.",
      ContactFormName: "New Year Gifts",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Custom Calendars & Diaries",
      parapgraphItalic: "Mark the Date in Style!",
      sectionparagraphText: (
        <>
          <p>
            Elevate everyday planning with calendars and diaries designed just for you. 
          </p>
          <p>
            Who says calendars and diaries need to be boring? At eYantra, we turn everyday essentials into extraordinary keepsakes. Whether it’s a sleek minimalist design or a vibrant splash of colours, our custom calendars and diaries help you make every date special. 
          </p>
        </>
      ),
      ImgSrc: "../assests/images/new-year/Custom Calendars & Diaries.jpg",
      
    },

    {
      index: 1,
      sectionName: "Celebrate the New Year with Thoughtful Corporate Gifts",
      parapgraphItalic: "Mark the Date in Style!",
      sectionparagraphText: (
        <>
          <p>
            At eYantra, we understand that gifting is not about transactions; it’s about building connections. Our personalized New Year corporate gifts are designed to reflect your company’s values while making every recipient feel genuinely appreciated. Whether you want elegant hampers for clients, sustainable gift sets for teams, or tech-forward presents for executives, we curate gifts that create impact and emotion.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/new-year/New Year Corporate Gifts.jpg",
      
    },
    

    /**Catagory Img */
    {
      index: 1,
      sectionName: "Popular Corporate New Year Gift Ideas ",
      parapgraphItalic: "",
      sectionparagraphText: (
        <>
         <p>
          Whether you're planning gifts for employees, clients, or business associates, here are some of the most in-demand gifting ideas from eYantra's New Year collection
         </p>
        </>
      ),
      ImgSrc: "../assests/images/new-year/Luxurious Gift Boxes.jpg",
      categoryHeadingLeftSide: "Features to Indulge In",
      CategoriesLeftContent: [
        {
          CategoryImg: "../assests/images/new-year/Premium Selections.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Premium Gift Hampers </b> <br></br>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/new-year/Customizable Hampers.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Tech Essentials</b> <br></br>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/new-year/Stunning Packaging.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Sustainable Gifts</b> <br></br>
              </p>
            </>
          ),
        },
        
      ],
    },
  ];
  const noGapContent = [
    {
      RightImgNogap: "../assests/images/new-year/Features That Wow.jpg",
      NogapHeading: "Why Corporate New Year Gifts Matter",
      paragraphDetail:"In the corporate world gifting is more than a tradition, it’s a powerful communication tool. A thoughtfully chosen corporate New Year gift can strengthen business ties, reinforce your brand identity, and set the tone for the year ahead",
      Heading: [
        {
          ListHeading: "Express Appreciation",
          ListParagraph:
            "Recognize the people who made your success possible.",
        },
        {
          ListHeading: "Strengthen Client Relationships",
          ListParagraph:
            "Show clients and partners that their collaboration is valued.",
        },
        {
          ListHeading: "Boost Employee Morale",
          ListParagraph:
            "Start the year with positivity and motivation.",
        },
        {
          ListHeading: "Enhance Brand Recall",
          ListParagraph:
            "Personalized gifts with your branding leave a lasting impression.",
        },
      ],
    },
    {
      RightImgNogap: "../assests/images/new-year/Personalized Desk Essentials.jpg",
      NogapHeading: "Tailored Gifting for Every Audience",
      paragraphItalic: "Desk Goals, Delivered!",
      paragraphDetail: (
        <>
         <p>
            We understand that not all recipients are the same, and a successful gifting strategy should reflect that diversity. Our New Year gifting solutions are designed to suit every type of audience
         </p>
        </>
      ),

      NogapSubheading: "Features That Shine",
      Categories: [
        {
          ServiceImg: "../assests/images/new-year/Name It, Own It.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Employee Gifts</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/new-year/Innovative Products.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Client Gifts</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/new-year/Elegant Aesthetics.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Vendor Gifts</b>
              </p>
            </>
          ),
        },
      ],
    },

    /**new index */
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
      NogapHeading: "Milestone Recognition ",
      paragraphItalic: "Make sure every gift reflects excellence.",
      paragraphDetail: (
        <>
          <p>Appreciate dedication and achievements.</p>
          <p>
            Show appreciation for the hard work and dedication that goes into
            every achievement.
          </p>
          <p>
            Milestones such as work anniversaries, project completions, and
            promotions deserve to be celebrated. At eYantra, we provide a range
            of premium milestone gifts that are as unique as the achievements.
          </p>
        </>
      ),

      NogapSubheading: "Our Milestone Gift Options Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/sub-pages/logo-printing.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Personalized Awards</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/sub-pages/engraving.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Luxury Gift Hampers</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/sub-pages/color-matching.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Luxury Gift Hampers</b>
              </p>
            </>
          ),
        },
      ],
    },
  ];

   const NoGapContentPoints =[
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-4.png",
      NogapHeading: "What Makes eYantra’s Corporate New Year Gifts Unique",
      Sectionparagraph:"eYantra has been a trusted name in the corporate gifting industry for over two decades, serving some of India’s most respected brands. Our focus has always been to create gifts that communicate purpose and value",
      Heading: [
        {
          ListHeading: "Personalized Gifting at Scale",
          ListParagraph: "From engraving logos to customizing packaging and messages, we make sure every personalised New Year corporate gift resonates with your brand identity.",
        },
        {
          ListHeading: "Premium Packaging and Presentation",
          ListParagraph:
            "We believe that presentation defines perception. That's why our premium New Year gift hampers for business come in elegantly designed boxes or sustainable materials, giving each gift an elevated feel.",
        },
        {
          ListHeading: "Sustainable and Eco-Friendly Options",
          ListParagraph:
            "Sustainability is no longer a trend; it's a responsibility. Our eco-friendly corporate gifts for New Year include reusable, biodegradable, and minimal-waste options that align with modern brand values.",
        },
      ],
     
    },
    {
      RightImgNogap: "../assests/images/new-year/How eYantra simplifies.jpg",
      NogapHeading: "How eYantra Simplifies the Gifting Process",
      Sectionparagraph:"We've refined our gifting model to make it effortless for HR and procurement teams to manage New Year gifting campaigns",
      Heading: [
        {
          ListHeading: "Consultation",
          ListParagraph: "Our experts understand your audience, budget, and brand message.",
        },
        {
          ListHeading: "Curation",
          ListParagraph:
            "We present a range of gift options tailored to your preferences.",
        },
        {
          ListHeading: "Customization",
          ListParagraph:
            "Add your branding, colors, and personalized messages.",
        },
        {
          ListHeading: "Delivery",
          ListParagraph:
            "Timely dispatch to offices or individual addresses across India.",
        },
      ],
     
    },
  ]

  const whyChooseData= [
     {
      whyChooseImg: "../assests/images/oldwhyChoose1.svg",
      whyChooseHeading: "Customization",
    },
    {
      whyChooseImg: "../assests/images/oldwhyChoose2.svg",
      whyChooseHeading: "Design Excellence",
    },
    {
      whyChooseImg: "../assests/images/oldwhyChoose3.svg",
      whyChooseHeading: "Nationwide Delivery",
    },
    {
      whyChooseImg: "../assests/images/whyChoose (4).svg",
      whyChooseHeading: "Corporate Expertise",
    },
  ]

  const faqsData = [
        {
          question: "Why are corporate New Year gifts important?",
          answer:
            "They help companies express appreciation, reinforce relationships, and start the new year with goodwill and positivity.",
        },
         {
          question: "Can eYantra personalize New Year gifts with company branding?",
          answer:
            "Yes, all gifts can be customized with your logo, message, and brand theme.",
        },
        {
          question: "What are some popular corporate New Year gift ideas?",
          answer:
            "Popular choices include premium hampers, branded planners, eco-friendly kits, tech gadgets, and wellness gifts.",
        },
        {
          question: "Does eYantra offer eco-friendly New Year gift options?",
          answer:
            "Absolutely, our eco-friendly range includes sustainable products made from bamboo, cork, jute, and recycled materials.",
        },
        {
          question: "How early should I plan my New Year gifting campaign?",
          answer:
            "It's best to begin 4,6 weeks before the New Year to allow time for customization and logistics.",
        },
        {
          question: "Can you deliver gifts to remote employees or clients?",
          answer:
            "Yes, we handle bulk and individual deliveries across India and internationally.",
        },
        {
          question: "Do you provide packaging customization?",
          answer:
            "Yes, we offer premium packaging options such as branded boxes, ribbons, sleeves, and inserts.",
        },
        {
          question: "How does eYantra ensure quality?",
          answer:
            "Every product undergoes strict quality checks, and our curation process ensures that each item meets premium standards.",
        },
        {
          question: "What is the minimum order quantity for corporate New Year gifts?",
          answer:
            "MOQ depends on the product type, but we cater to both small teams and large enterprises.",
        },
        {
          question: "Can we mix different products in one hamper?",
          answer:
            "Yes, our premium New Year gift hampers for business can include multiple curated items chosen to fit your theme.",
        },
        {
          question: "Are your New Year gift hampers customizable by budget?",
          answer:
            "Yes, we offer multiple pricing tiers to fit your corporate budget without compromising quality.",
        },
        {
          question: "Can you create gender-neutral or universal gift sets?",
          answer:
            "Yes, our team designs versatile, thoughtful hampers suitable for diverse workplaces.",
        },
      ]

  return (
    <>
      <Helmet>
        <title>
            Corporate New Year Gifts | Personalized and Premium New Year Gifting Solutions by eYantra.
        </title>
        <meta name="description" content="Explore eYantra's exclusive range of Corporate New Year Gifts that combine personalization, sustainability, and premium design. Discover how our custom gifting solutions help businesses build stronger relationships with clients and employees this festive season."/>
        <meta name="keywords" content="corporate new year gifts, personalized new year corporate gifts, premium new year gift hampers for business, branded corporate new year gifting solutions, eco-friendly corporate gifts for new year"/>
        </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
  
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      
      
      <NoGapContentpoints data={NoGapContentPoints[0]}/>
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <NoGapContentpoints data={NoGapContentPoints[1]}/>
      <NogapleftImg data={noGapContent[1]} />
      {/* <NoGapContentpoints data={NoGapContentPoints[1]}/> */}
      <Container className="my-5 text-center">
            <p className="fs-32 w-75 m-auto py-3">
              Each gift type can be tailored to align with your budget, brand tone, and message.
            </p>

            <a
              id="btnCTA"
              href="https://drive.google.com/file/d/1GzIckDhKWALkVPvgWK-a8ZWeo7VRue11/view"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary d-inline-flex align-items-center m-auto"
            >
              Download Catalog
            </a>
          </Container>

      <Whychooseus data={whyChooseData} />
      </div>
      <Container className="py-5">
        <h2>Frequently Asked Questions</h2>
      <DynamicFaqs faqsDynamicContent={faqsData} />
      </Container>
    </>
  );
};

export default NewYeargifts;
